"use client"

import { useEffect, useState } from "react"
import { endOfWeek, isSameDay, isWithinInterval, startOfWeek } from "date-fns"

import { EndHour, StartHour } from "../constants"

export function useCurrentTimeIndicator(
  currentDate,
  view,
  { startHour = StartHour, endHour = EndHour, weekStartsOn = 1 } = {}
) {
  const [currentTimePosition, setCurrentTimePosition] = useState(0)
  const [currentTimeVisible, setCurrentTimeVisible] = useState(false)

  useEffect(() => {
    const calculateTimePosition = () => {
      const now = new Date()
      const hours = now.getHours()
      const minutes = now.getMinutes()
      const totalMinutes = (hours - startHour) * 60 + minutes
      const dayStartMinutes = 0
      const dayEndMinutes = (endHour - startHour) * 60

      const position =
        ((totalMinutes - dayStartMinutes) / (dayEndMinutes - dayStartMinutes)) *
        100

      let isCurrentTimeVisible = false

      if (view === "day") {
        isCurrentTimeVisible = isSameDay(now, currentDate)
      } else if (view === "week") {
        const startOfWeekDate = startOfWeek(currentDate, { weekStartsOn })
        const endOfWeekDate = endOfWeek(currentDate, { weekStartsOn })
        isCurrentTimeVisible = isWithinInterval(now, {
          start: startOfWeekDate,
          end: endOfWeekDate,
        })
      }

      setCurrentTimePosition(position)
      setCurrentTimeVisible(isCurrentTimeVisible)
    }

    calculateTimePosition()

    const interval = setInterval(calculateTimePosition, 60000)

    return () => clearInterval(interval)
  }, [currentDate, view])

  return { currentTimePosition, currentTimeVisible }
}
